/**
 * Build /location-qr preview-count and bulk-generate selections from UI state.
 */

const floorNosForBlock = (floors, explicitFloorNos) => {
  const fromSelection = (explicitFloorNos || [])
    .map(f => Number(f))
    .filter(n => Number.isFinite(n));
  if (fromSelection.length > 0) return fromSelection;

  const fromMetadata = (floors || []).map(f => f.floor_no).filter(n => Number.isFinite(n));
  if (fromMetadata.length > 0) return fromMetadata;

  return [0];
};

const buildBlockFloorSelections = (selectedBlockIds, selectedFloors, blocksById) =>
  selectedBlockIds
    .map(blockId => {
      const block = blocksById?.[blockId];
      const floorNos = floorNosForBlock(block?.floors, selectedFloors[blockId]);
      if (floorNos.length === 0) return null;
      return {
        location_type: 'block_floor',
        block_id: blockId,
        floor_nos: floorNos,
      };
    })
    .filter(Boolean);

export const buildLocationQrSelections = (
  areaType,
  selectedBlockIds,
  selectedFloors,
  selectedItemIds,
  { streets = [] } = {}
) => {
  if (areaType === 'blocks') {
    return buildBlockFloorSelections(selectedBlockIds, selectedFloors, null);
  }

  if (areaType === 'streets' && selectedItemIds.length > 0) {
    const streetsById = Object.fromEntries(streets.map(s => [s.id, s]));
    return buildBlockFloorSelections(selectedItemIds, selectedFloors, streetsById);
  }

  if (areaType === 'amenities' && selectedItemIds.length > 0) {
    return [
      {
        location_type: 'amenity',
        amenity_ids: selectedItemIds,
      },
    ];
  }

  return [];
};
